import React from "react";
import { useContextDetection } from "../../hooks/useContextDetection";
import { Building2, Building } from "lucide-react";

const PageHeader = ({ pageName, entityName, entityType, className = "" }) => {
  const { isOrganizationContext, isBusinessUnitContext } =
    useContextDetection();

  // Determine the entity type and icon based on context if not provided
  const getEntityInfo = () => {
    if (entityType) {
      return {
        type: entityType,
        icon: entityType === "organization" ? Building2 : Building,
        label: entityType === "organization" ? "Organization" : "Business Unit",
      };
    }

    if (isOrganizationContext) {
      return {
        type: "organization",
        icon: Building2,
        label: "Organization",
      };
    }

    if (isBusinessUnitContext) {
      return {
        type: "business unit",
        icon: Building,
        label: "Business Unit",
      };
    }

    return {
      type: "unknown",
      icon: Building2,
      label: "Entity",
    };
  };

  const entityInfo = getEntityInfo();
  const IconComponent = entityInfo.icon;

  return (
    <div className={`flex items-center gap-4 mb-8 ${className}`}>
      <div className="flex-1">
        {entityName && (
          <div className="flex items-center gap-2 mb-1">
            <span className="text-sm text-muted-foreground">
              {entityInfo.label} / {entityName}
            </span>
          </div>
        )}
        <h1 className="text-heading-1">{pageName}</h1>
      </div>
    </div>
  );
};

export default PageHeader;
